export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY HH:mm'
export const DEFAULT_DATE_FORMAT_WITHOUT_TIME = 'DD/MM/YYYY'
export const DASHED_DATE_FORMAT = 'YYYY-MM-DD HH:mm'
export const DASHED_DATE_FORMAT_WITHOUT_TIME = 'YYYY-MM-DD'

export const BEGINNING_OF_TIME = '01/01/1970 08:00'
